module.exports = __webpack_public_path__ + "images/paper-plane-c00688da98bdf6c1b03a43fe7b5983f5.png";